import { z } from 'zod'

export const hexColorRegex = /^#[0-9a-fA-F]{6}$/
export const HexColor = z.string().regex(hexColorRegex)
export type HexColor = z.infer<typeof HexColor>
